import { createBrowserHistory as createHistory } from "history";
//automatically installed with react router dom1

export default createHistory();
